const message = {
	home: 'Home',
	aboutUs: 'About Us',
	areas: 'Areas',
	news: 'News',
	newDetails: 'News',
	contactUs: 'Contact Us',
	aboutIncocegla: 'About INCOCEGLA',
	ourFacilities: 'Our <br>facilities',
	glaucomaClub: 'Glaucoma Club',
	incoceglaFoundation: 'INCOCEGLA <br>Foundation',
	medicalEquipment: 'Medical Equipment',
	patients: 'Patients',
	press: 'Press',
	doctorsAndDepartments: 'Doctors and <br>departments',
	otherAreas: 'Other specialties',
	medicalInsurance: 'Medical Insurance',
	arsAffiliates: 'ARS Affiliates',
	pathologiesMoreConsulted: 'Pathologies more <br>consulted',
	faq: 'FAQ',
	visionTest: 'Vision test'
};

export default message;
